import { render, staticRenderFns } from "./userRemarkList.vue?vue&type=template&id=7eca966e&scoped=true"
import script from "./userRemarkList.vue?vue&type=script&lang=js"
export * from "./userRemarkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eca966e",
  null
  
)

export default component.exports